import React from 'react';
// @ts-ignore
import styles from './PatientDataVerificationVZPResult.module.scss';
import Button from '../../../../../Components/Button/Button';
import { Theme } from '../../../../../Enums/Theme.enum';
import useTranslation from '../../../../../Hooks/useTranslation';
import { getMomentDate } from '../../../../../Utils/dates.util';
import { useAppContext } from '../../../../../Services/AppContext';

export interface PatientDataVerificationVZPResultExtra {
	date: string;
	insurance: {
		type: string;
		title: string;
	};
}
interface Props {
	onClick: () => void;
	extra: PatientDataVerificationVZPResultExtra;
}

const PatientDataVerificationVZPResult: React.FC<Props> = ({
	onClick,
	extra,
}) => {
	const { t } = useTranslation();
	const { dateFormatMoment } = useAppContext();

	return (
		<div className={styles.wrapper}>
			<div>
				<div className={styles.title}>
					{t('component.patientDataVerificationVZPResult.dateTitle', {
						date: getMomentDate(extra.date).format(dateFormatMoment).toString(),
					})}
				</div>
			</div>
			<div>
				<div>
					{t('component.patientDataVerificationVZPResult.insuranceType')}:
				</div>
				<div className={styles.value}>{extra.insurance.type}</div>
			</div>
			<div>
				<div>
					{t('component.patientDataVerificationVZPResult.insuranceCompany')}:
				</div>
				<div className={styles.value}>{extra.insurance.title}</div>
			</div>
			<div>
				<Button
					theme={Theme.GREEN}
					title='base.shared.ok'
					onClick={onClick}
					className={styles.button}
				/>
			</div>
		</div>
	);
};

export default PatientDataVerificationVZPResult;
